import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { BfwUserContextService, PagedResponse_FollowedArtwork_ } from 'generatedBfw/static';

export interface FetchFollowing {
  enabled: boolean;
}

export const useDefaultFollowingQueryKey = ['following'];

export const useFollowingQueryKey = (offset: number, limit: number) => {
  const key: readonly [string, number, number] = ['following', offset, limit];
  return key;
};

export const useFollowing = (
  offset: number,
  limit: number,
  options?: Omit<
    UseQueryOptions<
      PagedResponse_FollowedArtwork_,
      Error,
      PagedResponse_FollowedArtwork_,
      readonly [string, number, number]
    >,
    'queryKey'
  >,
) => {
  return useQuery<
    PagedResponse_FollowedArtwork_,
    Error,
    PagedResponse_FollowedArtwork_,
    readonly [string, number, number]
  >(
    useFollowingQueryKey(offset, limit),
    () => BfwUserContextService.getFollowedArtworksV2(offset, limit),
    options,
  );
};
